module.exports = __webpack_public_path__ + "img/home-content-model-bg.d7f88aba.png";